import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { OrderSuccessModalPageRoutingModule } from './order-success-modal-routing.module';

import { OrderSuccessModalPage } from './order-success-modal.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    OrderSuccessModalPageRoutingModule,
    TranslateModule
  ],
  declarations: [OrderSuccessModalPage]
})
export class OrderSuccessModalPageModule {}
